import { MfaAccessControl } from '../../hooks/useMfaAccessControl';
import { AuthenticatorAppRow } from '../../hooks/useMfaMethodTypes';

import { AuthenticationMethodsTable } from './AuthenticationMethodsTable';
import { BackupCodeSection } from './BackupCodeSection';

interface AuthenticationMethodsListProps {
    authenticatorAppData: AuthenticatorAppRow[];
    hasRecoveryCode: boolean;
    accessControl: MfaAccessControl;
    userId: string;
}

export const AuthenticationMethodsList = ({
    authenticatorAppData,
    hasRecoveryCode,
    accessControl,
    userId,
}: AuthenticationMethodsListProps) => {
    return (
        <>
            <AuthenticationMethodsTable data={authenticatorAppData} accessControl={accessControl} userId={userId} />
            {hasRecoveryCode && accessControl.canViewBackupCodes ? <BackupCodeSection /> : null}
        </>
    );
};
